




































































import { Component, Vue, Watch } from 'vue-property-decorator';
import GlobalProgress from '@/components/global/Progress/index.vue';
import { eposPrint } from '@/utils/epos';
import { BookingModule } from '@/store/modules/booking';

@Component({
  name: 'Receipt',
  components: {
    GlobalProgress,
  },
})
export default class extends Vue {
  private supplierName = 'Dummy Supplier';
  private supplierId = 'Dummy SupplierId';
  private accountName = 'Dummy Account Name';
  private bookingId = 'OTAID-YYYYMMDD-XXXXX';
  private activityName = 'Dummy Activity Name';
  private planName = 'Dummy Plan Name';
  private participantName = 'Dummy Participant Name';
  private reprint = false;
  private tickets: {
    ticketName: string;
    ticketCount: number;
  }[] = [
    {
      ticketName: 'Dummy Ticket Name1',
      ticketCount: 1,
    },
    {
      ticketName: 'Dummy Ticket Name2',
      ticketCount: 1,
    },
  ];
  private issuedTime = 'YYYY-MM-DD hh:mm:ss';
  private autoPrint = false;

  mounted() {
    this.loadReiceptFromStore();
    if (this.autoPrint) {
      this.$nextTick(() => {
        this.printReceipt();
      });
    }
  }

  get isKintetsu() {
    return this.supplierId === '13750' || this.supplierId === 'kintetsu';
  }

  get kintetsuPlanName() {
    let planName;
    if (this.planName.includes('KINTETSU RAIL PASS （5 day）')) {
      planName = 'KRP-5day';
    } else if (this.planName.includes('KINTETSU RAIL PASS 1 day')) {
      planName = 'KRP-1day';
    } else if (this.planName.includes('KINTETSU RAIL PASS 2 day')) {
      planName = 'KRP-2day';
    } else if (this.planName.includes('KINTETSU RAIL PASS plus (5 day)')) {
      planName = 'KRP-(+PLUS)';
    } else {
      planName = this.planName;
    }
    return planName;
  }

  get kintetsuTickets() {
    return this.tickets.map(ticket => {
      return {
        ticketCount: ticket.ticketCount,
        ticketName: this.shortTicketName(ticket.ticketName),
      };
    });
  }

  shortTicketName(name: string) {
    if (name.includes('大人')) {
      return '大人 (12歳以上)';
    } else if (name.includes('子供')) {
      return '子供 (6-11歳)';
    }
    return name;
  }

  private loadReiceptFromStore() {
    BookingModule.LoadBookingIssueTicketReceipt();
    this.supplierName = BookingModule.issueTicketReceipt.supplierName;
    this.supplierId = BookingModule.issueTicketReceipt.supplierId;
    this.accountName = BookingModule.issueTicketReceipt.accountName;
    this.bookingId = BookingModule.issueTicketReceipt.bookingId;
    this.activityName = BookingModule.issueTicketReceipt.activityName;
    this.planName = BookingModule.issueTicketReceipt.planName;
    this.participantName = BookingModule.issueTicketReceipt.participantName;
    this.reprint = BookingModule.issueTicketReceipt.reprint;
    this.tickets = BookingModule.issueTicketReceipt.tickets;
    this.issuedTime = BookingModule.issueTicketReceipt.issuedTime;
    this.autoPrint = BookingModule.issueTicketReceipt.autoPrint;
  }

  private async printReceipt() {
    await this.$nextTick();
    setTimeout(() => {
      this.print();
    }, 300);
  }

  print() {
    if (this.isKintetsu) {
      location.href = eposPrint(
        this.kintetsuPlanName,
        this.kintetsuTickets,
        this.bookingId,
        this.accountName,
        this.issuedTime,
        this.reprint
      );
    } else {
      window.print();
    }
  }

  close() {
    window.close();
  }
}
